/**
 * Builds an `ai-from` query parameter value from the current URL.
 *
 * Strips copilot-specific query params (`ai-session`, `ai-message`) so they
 * don't leak into the destination URL as duplicate params when nuqs
 * re-serializes search params.
 *
 * Returns an unencoded path+search string — encoding is handled by
 * `generatePath`'s `query` parameter via `URLSearchParams`.
 */
export function buildAiFrom(): string {
  const url = new URL(window.location.href);
  url.searchParams.delete('ai-session');
  url.searchParams.delete('ai-message');

  const search = url.searchParams.toString();
  return search.length > 0 ? `${url.pathname}?${search}` : url.pathname;
}
